/* eslint-disable @typescript-eslint/no-explicit-any */
import { ERROR_MESSAGE } from "./constant";
/**
 * show error message for draft-error based on error code
 * response: api response
 */
export var draftCreateErrorMsg = function (response) {
    var _a, _b;
    var status = response.status;
    var statusCodes = [503, 410];
    if (statusCodes.includes(status)) {
        return (((_a = response === null || response === void 0 ? void 0 : response.details[0]) === null || _a === void 0 ? void 0 : _a.message) || ERROR_MESSAGE["SERVICE_DOWN"].message);
    }
    return ((_b = ERROR_MESSAGE[status]) === null || _b === void 0 ? void 0 : _b.message) || ERROR_MESSAGE["DEFAULT"].message;
};
